import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgentState {
  private agentListSub$ = new BehaviorSubject<Array<any>>([]);
  agentList$ = this.agentListSub$.asObservable();
  public get agentListValue(): Array<any> {
    return this.agentListSub$.value;
  }
  public set agentListValue(notes: Array<any>) {
    this.agentListSub$.next(notes);
  }
}
